var _rect, _rect2, _g, _path, _g2, _rect3, _rect4, _g3, _g4, _path2, _path3, _rect5, _rect6, _g5, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHighlightsHasLogoEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 236,
    viewBox: "0 0 256 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3516_19636)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 80.6914,
    width: 141.381,
    height: 141.381,
    rx: 5.41642,
    transform: "rotate(-30 22 80.6914)",
    fill: "url(#paint0_linear_3516_19636)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3516_19636",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 11,
    width: 191,
    height: 191
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.002,
    y: 80.6914,
    width: 141.381,
    height: 141.381,
    rx: 5.41642,
    transform: "rotate(-30 22.002 80.6914)",
    fill: "#323232"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3516_19636)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_3516_19636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.2276 89.9403C63.7224 103.41 47.4875 103.622 48.5167 117.446C50.2806 141.135 55.7453 150.226 47.2919 151.243C35.693 152.638 16.9971 137.357 6.87947 131.568C-3.44441 125.66 -12.4809 123.031 -16.2197 111.706C-20.5634 98.5476 -8.41229 91.3946 -5.04825 77.9108C-1.43913 63.4447 -6.59627 57.5686 5.89597 49.4516C19.2333 40.7854 65.8296 33.1542 81.4966 30.8967C103.372 27.7446 81.2114 44.5444 79.5969 61.9972C78.3554 75.4181 76.3818 85.4705 73.2276 89.9403Z",
    fill: "#CA5370"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_3516_19636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.371 22.1795C245.325 28.2519 237.741 30.9273 249.991 37.4162C261.195 43.3513 253.469 134.771 254.485 143.224C255.88 154.823 267.377 159.855 261.588 169.972C255.68 180.296 253.051 189.333 241.726 193.071C228.568 197.415 221.415 185.264 207.931 181.9C193.465 178.291 175.174 180.78 167.057 168.287C158.39 154.95 181.132 139.165 189.033 125.449C196.935 111.734 179.791 100.096 178.804 81.636C177.817 63.1763 203.241 21.1442 209.371 22.1795Z",
    fill: "#A2C166"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.447 143.467L98.5726 145.704L98.9984 147.979L97.414 148.894L95.379 137.713L97.1366 136.698L105.802 144.051L104.204 144.973L102.447 143.467ZM101.306 142.475L97.3186 139.043L98.2837 144.22L101.306 142.475ZM105.494 136.098L107.838 140.159C107.997 140.434 108.175 140.598 108.371 140.651C108.57 140.689 108.826 140.619 109.136 140.439L110.068 139.901L110.799 141.166L109.6 141.858C108.917 142.253 108.301 142.395 107.752 142.286C107.204 142.176 106.722 141.762 106.307 141.043L103.963 136.982L103.097 137.482L102.382 136.244L103.248 135.744L102.195 133.92L103.726 133.036L104.779 134.86L106.563 133.83L107.278 135.068L105.494 136.098ZM110.448 133.238L112.792 137.299C112.951 137.574 113.129 137.738 113.325 137.791C113.524 137.829 113.78 137.759 114.09 137.579L115.022 137.041L115.753 138.306L114.554 138.998C113.871 139.393 113.255 139.535 112.706 139.426C112.158 139.316 111.676 138.902 111.261 138.183L108.917 134.122L108.051 134.622L107.336 133.384L108.202 132.884L107.148 131.06L108.68 130.176L109.733 132L111.517 130.97L112.232 132.208L110.448 133.238ZM121.654 129.769C121.813 130.044 121.938 130.302 122.031 130.545L116.426 133.781C116.808 134.341 117.297 134.686 117.893 134.816C118.488 134.945 119.07 134.846 119.638 134.518C120.455 134.047 120.835 133.372 120.777 132.494L122.415 131.548C122.582 132.351 122.499 133.139 122.164 133.912C121.833 134.671 121.237 135.299 120.376 135.796C119.675 136.201 118.955 136.41 118.217 136.422C117.482 136.42 116.791 136.227 116.143 135.844C115.499 135.446 114.959 134.87 114.524 134.116C114.088 133.361 113.857 132.613 113.831 131.87C113.809 131.114 113.983 130.422 114.354 129.793C114.734 129.16 115.283 128.636 116.002 128.22C116.695 127.821 117.399 127.615 118.114 127.605C118.83 127.594 119.498 127.776 120.117 128.153C120.732 128.52 121.244 129.058 121.654 129.769ZM119.793 130.204C119.461 129.65 119.002 129.317 118.417 129.205C117.832 129.093 117.251 129.204 116.674 129.537C116.15 129.839 115.799 130.267 115.621 130.819C115.438 131.363 115.475 131.939 115.732 132.549L119.793 130.204ZM124.766 123.161C125.343 122.828 125.927 122.65 126.518 122.629C127.118 122.602 127.682 122.749 128.211 123.071C128.74 123.393 129.197 123.887 129.581 124.552L132.08 128.88L130.575 129.748L128.207 125.647C127.828 124.991 127.374 124.584 126.846 124.427C126.313 124.262 125.762 124.343 125.194 124.671C124.626 124.999 124.276 125.438 124.143 125.988C124.015 126.524 124.14 127.12 124.519 127.777L126.887 131.878L125.369 132.754L121.133 125.418L122.651 124.541L123.136 125.38C123.21 124.935 123.389 124.518 123.673 124.129C123.967 123.735 124.331 123.412 124.766 123.161ZM131.373 124.353C130.947 123.616 130.722 122.876 130.695 122.134C130.678 121.386 130.842 120.706 131.186 120.093C131.534 119.466 132.032 118.966 132.68 118.591C133.159 118.315 133.691 118.15 134.276 118.096C134.864 118.029 135.396 118.089 135.871 118.276L133.826 114.734L135.357 113.85L141.046 123.703L139.515 124.587L138.877 123.482C138.833 123.981 138.656 124.473 138.345 124.96C138.044 125.442 137.609 125.847 137.041 126.175C136.402 126.544 135.724 126.723 135.006 126.711C134.293 126.684 133.615 126.473 132.971 126.075C132.331 125.663 131.798 125.089 131.373 124.353ZM137.393 120.912C137.101 120.406 136.741 120.028 136.312 119.779C135.893 119.524 135.458 119.396 135.008 119.395C134.558 119.395 134.138 119.507 133.747 119.733C133.357 119.958 133.049 120.266 132.825 120.656C132.595 121.037 132.481 121.476 132.483 121.972C132.489 122.453 132.638 122.947 132.931 123.453C133.223 123.959 133.581 124.344 134.005 124.608C134.439 124.866 134.883 125.001 135.338 125.01C135.797 125.005 136.218 124.893 136.599 124.673C136.99 124.447 137.297 124.139 137.522 123.749C137.746 123.359 137.853 122.919 137.842 122.428C137.835 121.924 137.685 121.418 137.393 120.912ZM147.542 114.822C147.7 115.097 147.826 115.356 147.919 115.598L142.313 118.835C142.696 119.395 143.185 119.74 143.781 119.869C144.376 119.999 144.958 119.9 145.526 119.572C146.343 119.1 146.722 118.425 146.665 117.547L148.303 116.602C148.47 117.404 148.387 118.192 148.052 118.966C147.721 119.725 147.125 120.353 146.264 120.85C145.563 121.255 144.843 121.463 144.104 121.476C143.37 121.474 142.678 121.281 142.031 120.897C141.387 120.5 140.847 119.924 140.412 119.169C139.976 118.415 139.745 117.666 139.719 116.924C139.697 116.168 139.871 115.475 140.242 114.847C140.622 114.213 141.171 113.689 141.89 113.274C142.582 112.874 143.287 112.669 144.002 112.658C144.718 112.647 145.386 112.83 146.005 113.206C146.619 113.573 147.132 114.112 147.542 114.822ZM145.68 115.258C145.349 114.703 144.89 114.371 144.305 114.259C143.72 114.147 143.138 114.258 142.562 114.591C142.038 114.893 141.687 115.32 141.509 115.873C141.326 116.417 141.363 116.993 141.62 117.602L145.68 115.258ZM155.759 110.078C155.918 110.353 156.044 110.612 156.136 110.854L150.531 114.09C150.914 114.651 151.403 114.995 151.998 115.125C152.594 115.255 153.176 115.155 153.744 114.827C154.56 114.356 154.94 113.681 154.883 112.803L156.52 111.857C156.688 112.66 156.604 113.448 156.27 114.221C155.939 114.98 155.343 115.608 154.482 116.106C153.78 116.51 153.061 116.719 152.322 116.731C151.587 116.729 150.896 116.537 150.248 116.153C149.605 115.755 149.065 115.179 148.629 114.425C148.194 113.67 147.963 112.922 147.937 112.18C147.914 111.423 148.088 110.731 148.459 110.103C148.839 109.469 149.389 108.945 150.108 108.53C150.8 108.13 151.504 107.925 152.22 107.914C152.935 107.903 153.603 108.086 154.223 108.462C154.837 108.829 155.349 109.368 155.759 110.078ZM153.898 110.513C153.566 109.959 153.108 109.626 152.522 109.514C151.937 109.403 151.356 109.513 150.779 109.846C150.255 110.149 149.904 110.576 149.726 111.129C149.543 111.672 149.58 112.249 149.837 112.858L153.898 110.513ZM162.207 111.646C161.63 111.979 161.051 112.176 160.472 112.239C159.896 112.287 159.373 112.211 158.902 112.009C158.425 111.799 158.05 111.477 157.776 111.044L159.347 110.137C159.553 110.432 159.851 110.609 160.24 110.668C160.633 110.714 161.034 110.619 161.442 110.383C161.868 110.137 162.15 109.867 162.289 109.574C162.431 109.267 162.428 108.985 162.279 108.728C162.121 108.452 161.87 108.325 161.526 108.346C161.192 108.361 160.695 108.453 160.034 108.621C159.397 108.788 158.864 108.9 158.436 108.958C158.008 109.016 157.58 108.973 157.154 108.829C156.736 108.679 156.389 108.365 156.112 107.886C155.887 107.495 155.797 107.073 155.844 106.62C155.885 106.159 156.065 105.712 156.383 105.279C156.71 104.842 157.154 104.462 157.713 104.139C158.547 103.657 159.34 103.483 160.092 103.617C160.848 103.737 161.454 104.151 161.909 104.858L160.392 105.734C160.175 105.421 159.891 105.236 159.539 105.18C159.186 105.123 158.806 105.212 158.397 105.448C157.998 105.678 157.735 105.931 157.609 106.205C157.484 106.478 157.492 106.74 157.636 106.988C157.749 107.183 157.914 107.307 158.133 107.358C158.352 107.409 158.587 107.416 158.837 107.378C159.082 107.331 159.438 107.25 159.904 107.134C160.518 106.969 161.038 106.864 161.462 106.82C161.891 106.763 162.311 106.804 162.723 106.945C163.136 107.085 163.482 107.388 163.763 107.853C164.004 108.271 164.104 108.71 164.062 109.172C164.021 109.633 163.842 110.08 163.523 110.513C163.213 110.94 162.775 111.318 162.207 111.646Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3516_19636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.279 101.887L128.719 99.1844C127.891 97.7509 126.528 96.7049 124.929 96.2765C123.33 95.8481 121.627 96.0724 120.193 96.9L109.383 103.141C107.95 103.969 106.904 105.332 106.476 106.931C106.047 108.53 106.271 110.233 107.099 111.667L108.659 114.369",
    stroke: "white",
    strokeWidth: 1.80547,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.67 94.6191C114.655 92.8956 115.677 89.0786 113.954 86.0935C112.231 83.1084 108.414 82.0857 105.428 83.8091C102.443 85.5326 101.421 89.3496 103.144 92.3347C104.867 95.3198 108.684 96.3425 111.67 94.6191Z",
    stroke: "white",
    strokeWidth: 1.80547,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3516_19636)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 61.3789,
    width: 140.55,
    height: 140.55,
    rx: 5.59128,
    transform: "rotate(-15 56 61.3789)",
    fill: "url(#paint1_linear_3516_19636)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3516_19636",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 26,
    width: 170,
    height: 170
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 61.3789,
    width: 140.55,
    height: 140.55,
    rx: 5.59128,
    transform: "rotate(-15 56 61.3789)",
    fill: "#323232"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3516_19636)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dd_3516_19636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.2478 191.864C95.5842 179.678 104.804 175.467 117.976 171.417C130.024 167.714 139.542 181.363 146.199 186.591C155.333 193.763 166.952 189.218 169.994 200.4C173.099 211.81 177.603 220.011 172.27 230.6C166.074 242.903 152.504 239.39 140.66 246.503C127.954 254.135 127.449 261.891 112.962 258.816C97.4943 255.532 96.4614 247.443 92.3745 232.247C88.2671 216.975 83.5991 202.727 89.2478 191.864Z",
    fill: "#CA5370"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dd_3516_19636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.53 -27.6569C156.111 -35.0421 166.201 -34.0791 179.633 -30.9999C191.919 -28.1835 193.337 -11.604 196.488 -3.7482C200.812 7.03073 213.147 8.90383 210.191 20.1089C207.174 31.5425 206.975 40.8963 197.061 47.4006C185.544 54.9571 175.549 45.1294 161.735 45.3685C146.916 45.6249 142.6 52.089 131.591 42.1818C119.838 31.6044 122.988 24.0829 127.046 8.87949C131.125 -6.40011 134.207 -21.0732 144.53 -27.6569Z",
    fill: "#4AC1C0"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3516_19636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.562 77.043L134.529 84.3814",
    stroke: "white",
    strokeWidth: 1.86376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.428 106.395L142.394 113.733",
    stroke: "white",
    strokeWidth: 1.86376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.033 85.8906L127.616 89.6914",
    stroke: "white",
    strokeWidth: 1.86376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.34 101.074L153.923 104.875",
    stroke: "white",
    strokeWidth: 1.86376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.135 100.309L126.473 98.3423",
    stroke: "white",
    strokeWidth: 1.86376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.488 92.4414L155.827 90.4751",
    stroke: "white",
    strokeWidth: 1.86376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.981 111.825L131.782 105.242",
    stroke: "white",
    strokeWidth: 1.86376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.174 85.524L146.975 78.9409",
    stroke: "white",
    strokeWidth: 1.86376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.693 88.7241L138.872 92.3436L143.662 91.7815L141.196 95.9208L143.212 100.295L138.509 99.2337L134.966 102.504L134.525 97.7084L130.32 95.3567L134.749 93.4484L135.693 88.7241Z",
    stroke: "white",
    strokeWidth: 1.86376
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.801 138.124L106.613 141.154L110.177 140.199L110.547 141.58L106.983 142.535L107.831 145.698L111.84 144.624L112.21 146.005L106.508 147.533L103.738 137.197L109.441 135.669L109.811 137.05L105.801 138.124ZM117.053 143.084L117.583 135.795L119.38 135.314L118.454 144.332L116.434 144.873L111.138 137.522L112.949 137.036L117.053 143.084ZM129.201 136.852C129.284 137.159 129.338 137.441 129.365 137.7L123.113 139.375C123.337 140.015 123.72 140.475 124.262 140.754C124.804 141.033 125.392 141.088 126.025 140.918C126.936 140.674 127.477 140.121 127.649 139.257L129.476 138.768C129.43 139.587 129.145 140.326 128.622 140.986C128.106 141.634 127.367 142.086 126.407 142.344C125.625 142.553 124.876 142.568 124.159 142.389C123.45 142.197 122.832 141.832 122.306 141.294C121.787 140.743 121.415 140.047 121.189 139.206C120.964 138.364 120.934 137.582 121.101 136.858C121.275 136.121 121.623 135.498 122.144 134.987C122.675 134.473 123.341 134.109 124.143 133.894C124.915 133.687 125.648 133.671 126.343 133.846C127.037 134.021 127.634 134.37 128.135 134.893C128.634 135.407 128.989 136.06 129.201 136.852ZM127.291 136.791C127.114 136.17 126.757 135.73 126.221 135.47C125.684 135.211 125.094 135.167 124.451 135.339C123.867 135.496 123.417 135.818 123.102 136.306C122.784 136.783 122.671 137.35 122.761 138.005L127.291 136.791ZM133.917 131.275C134.561 131.102 135.171 131.082 135.747 131.214C136.334 131.344 136.841 131.632 137.269 132.08C137.696 132.528 138.01 133.123 138.209 133.865L139.502 138.692L137.824 139.141L136.598 134.568C136.402 133.835 136.069 133.325 135.599 133.037C135.127 132.739 134.574 132.675 133.94 132.845C133.306 133.014 132.855 133.348 132.584 133.844C132.322 134.329 132.288 134.937 132.485 135.67L133.71 140.244L132.017 140.697L129.825 132.515L131.518 132.061L131.768 132.997C131.955 132.586 132.237 132.229 132.612 131.927C132.997 131.622 133.432 131.405 133.917 131.275ZM141.814 130.782L143.028 135.312C143.11 135.619 143.239 135.823 143.415 135.924C143.598 136.013 143.862 136.011 144.209 135.919L145.248 135.64L145.626 137.051L144.29 137.409C143.528 137.613 142.896 137.591 142.394 137.344C141.893 137.096 141.535 136.571 141.32 135.769L140.106 131.24L139.141 131.499L138.771 130.118L139.736 129.859L139.191 127.824L140.899 127.367L141.444 129.401L143.434 128.868L143.804 130.249L141.814 130.782ZM150.193 135.971C149.549 136.143 148.939 136.184 148.364 136.095C147.795 135.992 147.309 135.783 146.906 135.466C146.5 135.14 146.221 134.732 146.069 134.242L147.821 133.773C147.944 134.111 148.185 134.36 148.546 134.518C148.914 134.663 149.326 134.675 149.781 134.553C150.256 134.425 150.599 134.238 150.808 133.991C151.025 133.731 151.095 133.458 151.018 133.171C150.936 132.864 150.726 132.676 150.39 132.607C150.063 132.535 149.559 132.495 148.877 132.487C148.218 132.483 147.675 132.454 147.246 132.399C146.817 132.344 146.416 132.192 146.041 131.942C145.676 131.689 145.422 131.296 145.279 130.761C145.163 130.326 145.185 129.895 145.347 129.47C145.506 129.034 145.796 128.649 146.215 128.314C146.645 127.976 147.171 127.724 147.795 127.556C148.725 127.307 149.537 127.344 150.228 127.668C150.927 127.98 151.405 128.536 151.662 129.337L149.969 129.791C149.841 129.433 149.615 129.18 149.289 129.034C148.963 128.888 148.573 128.876 148.117 128.998C147.672 129.117 147.353 129.293 147.16 129.525C146.968 129.757 146.909 130.012 146.983 130.289C147.041 130.507 147.17 130.669 147.368 130.775C147.566 130.881 147.791 130.948 148.043 130.976C148.291 130.994 148.656 131.008 149.136 131.017C149.772 131.016 150.301 131.05 150.723 131.117C151.151 131.172 151.546 131.321 151.909 131.563C152.271 131.806 152.527 132.188 152.677 132.71C152.802 133.176 152.785 133.626 152.626 134.061C152.466 134.496 152.177 134.882 151.757 135.217C151.348 135.55 150.826 135.801 150.193 135.971ZM164.454 120.944L167.219 131.265L165.526 131.719L164.317 127.204L159.46 128.505L160.67 133.02L158.977 133.473L156.212 123.152L157.905 122.699L159.09 127.124L163.946 125.823L162.761 121.398L164.454 120.944ZM175.797 124.367C175.88 124.673 175.934 124.956 175.961 125.214L169.709 126.889C169.933 127.53 170.316 127.989 170.858 128.269C171.4 128.548 171.988 128.603 172.621 128.433C173.532 128.189 174.073 127.635 174.245 126.772L176.072 126.283C176.026 127.101 175.741 127.841 175.218 128.501C174.702 129.149 173.964 129.601 173.003 129.858C172.221 130.068 171.472 130.083 170.755 129.904C170.046 129.712 169.428 129.347 168.902 128.809C168.383 128.258 168.011 127.562 167.785 126.72C167.56 125.879 167.53 125.096 167.697 124.372C167.871 123.636 168.219 123.012 168.74 122.501C169.271 121.988 169.937 121.623 170.739 121.409C171.511 121.202 172.244 121.186 172.939 121.36C173.633 121.535 174.23 121.884 174.731 122.408C175.23 122.922 175.585 123.575 175.797 124.367ZM173.887 124.305C173.71 123.684 173.353 123.244 172.817 122.985C172.28 122.725 171.69 122.682 171.047 122.854C170.463 123.011 170.013 123.333 169.698 123.82C169.38 124.298 169.267 124.864 169.358 125.519L173.887 124.305ZM177.362 116.769L180.306 127.758L178.613 128.212L175.669 117.223L177.362 116.769ZM180.858 123.186C180.638 122.364 180.612 121.591 180.778 120.867C180.955 120.141 181.289 119.526 181.78 119.023C182.279 118.507 182.89 118.153 183.612 117.959C184.147 117.816 184.703 117.794 185.282 117.894C185.868 117.981 186.366 118.176 186.776 118.48L185.718 114.53L187.425 114.072L190.37 125.062L188.662 125.519L188.332 124.287C188.161 124.757 187.862 125.187 187.436 125.577C187.02 125.965 186.495 126.243 185.862 126.413C185.149 126.604 184.448 126.601 183.758 126.404C183.076 126.194 182.475 125.814 181.956 125.263C181.445 124.7 181.079 124.007 180.858 123.186ZM187.564 121.421C187.413 120.856 187.163 120.398 186.814 120.046C186.474 119.691 186.088 119.455 185.653 119.338C185.218 119.221 184.783 119.221 184.348 119.338C183.912 119.455 183.535 119.672 183.218 119.991C182.897 120.3 182.674 120.694 182.548 121.173C182.429 121.64 182.445 122.156 182.596 122.72C182.747 123.284 182.994 123.749 183.335 124.114C183.687 124.476 184.082 124.72 184.519 124.847C184.963 124.961 185.398 124.961 185.824 124.847C186.26 124.731 186.636 124.513 186.954 124.194C187.272 123.876 187.489 123.478 187.605 123.001C187.729 122.512 187.715 121.985 187.564 121.421Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_3516_19636)"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 85.5781,
    y: 43,
    width: 146.803,
    height: 154.075,
    rx: 5.76535,
    fill: "url(#paint2_linear_3516_19636)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3516_19636",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 43,
    width: 148,
    height: 155
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 85.5781,
    y: 43,
    width: 146.803,
    height: 154.075,
    rx: 5.76535,
    fill: "#323232"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3516_19636)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_dd_3516_19636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.445 10.694C215.541 2.59809 226.08 3.6537 240.11 7.02921C252.942 10.1166 254.423 28.2915 257.715 36.9033C262.231 48.7194 275.115 50.7728 272.027 63.0561C268.876 75.5899 268.668 85.8438 258.314 92.9739C246.284 101.258 251.84 116.365 240.11 107.544C224.051 95.4677 203.808 95.5014 192.31 84.6409C180.033 73.0456 185.183 67.5668 185.184 50.7461C185.184 33.4096 192.663 17.9111 203.445 10.694Z",
    fill: "#9C6EBA"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_dd_3516_19636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9536 151.028C48.4174 138.81 61.0414 136.782 78.4877 136.176C94.4451 135.622 102.079 154.494 108.713 162.663C117.817 173.87 126.766 173.984 133.893 186.179C141.415 199.051 137.385 211.4 127.637 222.072C116.311 234.471 100.644 226.142 83.9158 230.732C65.9693 235.657 63.0199 244.535 46.0905 236.429C28.0159 227.776 29.1697 218.03 28.6921 199.051C28.2121 179.977 26.7341 161.921 36.9536 151.028Z",
    fill: "#F1CD60"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M155.004 100.617L157.006 101.83",
    stroke: "white",
    strokeWidth: 1.40518,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.625 102.812L160.627 104.026",
    stroke: "white",
    strokeWidth: 1.40518,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.043 104.887L164.045 106.1",
    stroke: "white",
    strokeWidth: 1.40518,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.984 88.8299C161.49 88.5347 160.857 88.7117 160.571 89.2253L155.041 99.145C155.088 99.2404 155.125 99.3414 155.152 99.4467C155.252 99.8374 155.198 100.254 155.002 100.606C154.806 100.957 154.485 101.214 154.108 101.32C154.007 101.348 153.904 101.365 153.8 101.371L146.001 115.363C145.715 115.876 145.883 116.532 146.378 116.827L148.722 118.227C148.885 117.997 149.142 117.87 149.407 117.871C149.555 117.871 149.706 117.912 149.845 117.996L152.164 119.401C152.303 119.485 152.411 119.602 152.486 119.737C152.615 119.969 152.641 120.254 152.545 120.51L154.737 121.819C155.231 122.114 155.864 121.937 156.151 121.424L163.436 108.355L163.901 107.52C163.848 107.416 163.806 107.306 163.776 107.19C163.676 106.8 163.73 106.383 163.926 106.032C164.122 105.68 164.444 105.424 164.82 105.318C164.931 105.286 165.045 105.269 165.158 105.265L170.721 95.2865C171.007 94.773 170.838 94.1173 170.344 93.8221L161.984 88.8299ZM159.377 88.5125C160.045 87.3142 161.522 86.9012 162.675 87.5901L171.035 92.5823C172.188 93.2711 172.582 94.801 171.914 95.9993L166.089 106.449L165.559 106.128L165.559 106.128C165.208 105.923 164.763 106.05 164.56 106.414C164.356 106.779 164.475 107.246 164.826 107.455L164.828 107.456L164.823 107.464L165.346 107.781L164.629 109.068L157.344 122.137C156.676 123.335 155.199 123.748 154.046 123.059L151.229 121.377L151.911 120.136L149.364 118.593L148.672 119.85L145.686 118.067C144.533 117.378 144.139 115.848 144.807 114.65L152.856 100.212L153.357 100.512L153.359 100.507L153.364 100.51C153.714 100.719 154.164 100.593 154.368 100.227C154.572 99.8614 154.453 99.3951 154.102 99.1854L154.094 99.1806L153.596 98.8828L159.377 88.5125Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.923 136.432V137.862H118.078V147.117H116.326V137.862H113.466V136.432H120.923ZM123.589 137.524C123.272 137.524 123.005 137.416 122.79 137.201C122.575 136.986 122.467 136.719 122.467 136.401C122.467 136.084 122.575 135.817 122.79 135.602C123.005 135.387 123.272 135.279 123.589 135.279C123.897 135.279 124.158 135.387 124.373 135.602C124.589 135.817 124.696 136.084 124.696 136.401C124.696 136.719 124.589 136.986 124.373 137.201C124.158 137.416 123.897 137.524 123.589 137.524ZM124.45 138.646V147.117H122.698V138.646H124.45ZM126.167 142.874C126.167 142.003 126.341 141.239 126.69 140.583C127.049 139.917 127.541 139.404 128.166 139.046C128.791 138.687 129.509 138.508 130.318 138.508C131.343 138.508 132.189 138.754 132.855 139.246C133.531 139.727 133.988 140.419 134.223 141.321H132.332C132.179 140.901 131.933 140.573 131.594 140.337C131.256 140.101 130.831 139.984 130.318 139.984C129.601 139.984 129.027 140.24 128.596 140.752C128.176 141.254 127.966 141.962 127.966 142.874C127.966 143.786 128.176 144.498 128.596 145.011C129.027 145.523 129.601 145.78 130.318 145.78C131.333 145.78 132.004 145.334 132.332 144.442H134.223C133.977 145.303 133.516 145.99 132.84 146.502C132.163 147.004 131.323 147.256 130.318 147.256C129.509 147.256 128.791 147.076 128.166 146.717C127.541 146.348 127.049 145.836 126.69 145.18C126.341 144.514 126.167 143.745 126.167 142.874ZM139.322 142.889L143.227 147.117H140.859L137.723 143.473V147.117H135.97V135.74H137.723V142.351L140.798 138.646H143.227L139.322 142.889ZM152.247 142.674C152.247 142.992 152.226 143.279 152.185 143.535H145.713C145.764 144.211 146.015 144.755 146.466 145.165C146.917 145.575 147.471 145.78 148.127 145.78C149.07 145.78 149.736 145.385 150.125 144.596H152.016C151.76 145.375 151.294 146.015 150.617 146.518C149.951 147.01 149.121 147.256 148.127 147.256C147.317 147.256 146.589 147.076 145.943 146.717C145.308 146.348 144.806 145.836 144.437 145.18C144.078 144.514 143.899 143.745 143.899 142.874C143.899 142.003 144.073 141.239 144.421 140.583C144.78 139.917 145.277 139.404 145.913 139.046C146.558 138.687 147.296 138.508 148.127 138.508C148.926 138.508 149.638 138.682 150.264 139.03C150.889 139.379 151.376 139.871 151.724 140.506C152.073 141.131 152.247 141.854 152.247 142.674ZM150.417 142.121C150.407 141.475 150.176 140.957 149.726 140.568C149.275 140.178 148.716 139.984 148.05 139.984C147.445 139.984 146.927 140.178 146.497 140.568C146.066 140.947 145.81 141.465 145.728 142.121H150.417ZM156.016 140.076V144.765C156.016 145.083 156.088 145.313 156.232 145.457C156.385 145.59 156.642 145.657 157 145.657H158.077V147.117H156.693C155.904 147.117 155.299 146.933 154.879 146.564C154.459 146.195 154.248 145.595 154.248 144.765V140.076H153.249V138.646H154.248V136.54H156.016V138.646H158.077V140.076H156.016ZM162.767 147.256C162.101 147.256 161.501 147.138 160.968 146.902C160.445 146.656 160.03 146.328 159.723 145.918C159.415 145.498 159.251 145.031 159.231 144.519H161.045C161.076 144.878 161.245 145.18 161.552 145.426C161.87 145.662 162.265 145.78 162.736 145.78C163.228 145.78 163.607 145.687 163.874 145.503C164.151 145.308 164.289 145.062 164.289 144.765C164.289 144.447 164.135 144.211 163.828 144.058C163.53 143.904 163.054 143.735 162.398 143.55C161.762 143.376 161.245 143.207 160.845 143.043C160.445 142.879 160.097 142.628 159.8 142.29C159.513 141.951 159.369 141.506 159.369 140.952C159.369 140.501 159.502 140.091 159.769 139.722C160.035 139.343 160.415 139.046 160.907 138.83C161.409 138.615 161.983 138.508 162.628 138.508C163.592 138.508 164.366 138.754 164.95 139.246C165.544 139.727 165.862 140.388 165.903 141.229H164.151C164.12 140.85 163.966 140.547 163.689 140.322C163.413 140.096 163.038 139.984 162.567 139.984C162.106 139.984 161.752 140.071 161.506 140.245C161.26 140.419 161.137 140.65 161.137 140.937C161.137 141.162 161.219 141.352 161.383 141.506C161.547 141.659 161.747 141.782 161.983 141.875C162.219 141.957 162.567 142.064 163.028 142.197C163.643 142.361 164.145 142.531 164.535 142.705C164.935 142.869 165.278 143.115 165.565 143.443C165.852 143.771 166.001 144.206 166.011 144.75C166.011 145.231 165.878 145.662 165.611 146.041C165.345 146.42 164.965 146.717 164.473 146.933C163.992 147.148 163.423 147.256 162.767 147.256ZM175.419 147.225C174.702 147.225 174.056 147.102 173.482 146.856C172.908 146.6 172.457 146.241 172.129 145.78C171.801 145.318 171.637 144.78 171.637 144.165H173.513C173.554 144.627 173.733 145.006 174.051 145.303C174.379 145.6 174.835 145.749 175.419 145.749C176.024 145.749 176.495 145.605 176.833 145.318C177.172 145.021 177.341 144.642 177.341 144.181C177.341 143.822 177.233 143.53 177.018 143.304C176.813 143.079 176.552 142.905 176.234 142.782C175.926 142.659 175.496 142.525 174.942 142.382C174.245 142.197 173.677 142.013 173.236 141.828C172.805 141.634 172.436 141.336 172.129 140.937C171.821 140.537 171.668 140.004 171.668 139.338C171.668 138.723 171.821 138.185 172.129 137.724C172.436 137.262 172.867 136.909 173.42 136.663C173.974 136.417 174.614 136.294 175.342 136.294C176.377 136.294 177.223 136.555 177.879 137.078C178.545 137.59 178.914 138.297 178.986 139.199H177.049C177.018 138.81 176.833 138.477 176.495 138.2C176.157 137.923 175.711 137.785 175.158 137.785C174.655 137.785 174.245 137.913 173.928 138.169C173.61 138.426 173.451 138.795 173.451 139.276C173.451 139.604 173.549 139.876 173.743 140.091C173.948 140.296 174.204 140.46 174.512 140.583C174.819 140.706 175.24 140.839 175.773 140.983C176.48 141.178 177.054 141.372 177.495 141.567C177.946 141.762 178.325 142.064 178.632 142.474C178.95 142.874 179.109 143.412 179.109 144.088C179.109 144.632 178.96 145.144 178.663 145.626C178.376 146.108 177.951 146.497 177.387 146.794C176.833 147.081 176.178 147.225 175.419 147.225ZM184.851 147.256C184.052 147.256 183.329 147.076 182.684 146.717C182.038 146.348 181.531 145.836 181.162 145.18C180.793 144.514 180.608 143.745 180.608 142.874C180.608 142.013 180.798 141.249 181.177 140.583C181.556 139.917 182.074 139.404 182.73 139.046C183.386 138.687 184.119 138.508 184.928 138.508C185.738 138.508 186.471 138.687 187.127 139.046C187.783 139.404 188.3 139.917 188.68 140.583C189.059 141.249 189.248 142.013 189.248 142.874C189.248 143.735 189.054 144.498 188.664 145.165C188.275 145.831 187.742 146.348 187.065 146.717C186.399 147.076 185.661 147.256 184.851 147.256ZM184.851 145.734C185.302 145.734 185.723 145.626 186.112 145.411C186.512 145.195 186.835 144.873 187.081 144.442C187.327 144.012 187.45 143.489 187.45 142.874C187.45 142.259 187.332 141.741 187.096 141.321C186.86 140.891 186.548 140.568 186.158 140.353C185.769 140.137 185.349 140.03 184.898 140.03C184.447 140.03 184.026 140.137 183.637 140.353C183.258 140.568 182.955 140.891 182.73 141.321C182.504 141.741 182.392 142.259 182.392 142.874C182.392 143.786 182.622 144.493 183.083 144.996C183.555 145.488 184.144 145.734 184.851 145.734ZM192.734 135.74V147.117H190.981V135.74H192.734ZM194.451 142.843C194.451 141.992 194.625 141.239 194.973 140.583C195.332 139.927 195.814 139.42 196.419 139.061C197.033 138.692 197.715 138.508 198.463 138.508C199.017 138.508 199.56 138.631 200.093 138.877C200.636 139.112 201.067 139.43 201.384 139.83V135.74H203.152V147.117H201.384V145.841C201.097 146.251 200.698 146.589 200.185 146.856C199.683 147.122 199.104 147.256 198.448 147.256C197.71 147.256 197.033 147.071 196.419 146.702C195.814 146.323 195.332 145.8 194.973 145.134C194.625 144.457 194.451 143.694 194.451 142.843ZM201.384 142.874C201.384 142.29 201.261 141.782 201.015 141.352C200.78 140.921 200.467 140.593 200.078 140.368C199.688 140.142 199.268 140.03 198.817 140.03C198.366 140.03 197.946 140.142 197.556 140.368C197.167 140.583 196.849 140.906 196.603 141.336C196.367 141.757 196.249 142.259 196.249 142.843C196.249 143.427 196.367 143.94 196.603 144.381C196.849 144.821 197.167 145.16 197.556 145.395C197.956 145.621 198.376 145.734 198.817 145.734C199.268 145.734 199.688 145.621 200.078 145.395C200.467 145.17 200.78 144.842 201.015 144.411C201.261 143.971 201.384 143.458 201.384 142.874Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3516_19636",
    x: 0.921007,
    y: 0.581668,
    width: 235.291,
    height: 235.287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.6587
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.5307
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0875 0 0 0 0 0.0875 0 0 0 0 0.0875 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3516_19636"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3516_19636",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_3516_19636",
    x: -70.8855,
    y: -12.2352,
    width: 215.712,
    height: 228.298,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.9921
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.8695
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.403922 0 0 0 0 0.545098 0 0 0 0 0.552941 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3516_19636"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.88537
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54939
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.40408 0 0 0 0 0.546662 0 0 0 0 0.554167 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3516_19636",
    result: "effect2_dropShadow_3516_19636"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3516_19636",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_3516_19636",
    x: 111.38,
    y: -20.5868,
    width: 205.566,
    height: 279.318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.9921
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.8695
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.403922 0 0 0 0 0.545098 0 0 0 0 0.552941 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3516_19636"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.88537
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54939
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.40408 0 0 0 0 0.546662 0 0 0 0 0.554167 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3516_19636",
    result: "effect2_dropShadow_3516_19636"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3516_19636",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3516_19636",
    x: 34.1944,
    y: 14.8551,
    width: 215.75,
    height: 215.748,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.6587
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.5307
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0875 0 0 0 0 0.0875 0 0 0 0 0.0875 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3516_19636"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3516_19636",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dd_3516_19636",
    x: 31.1608,
    y: 126.662,
    width: 199.053,
    height: 199.663,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.3469
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27.737
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.403922 0 0 0 0 0.545098 0 0 0 0 0.552941 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3516_19636"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.04309
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.8254
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.40408 0 0 0 0 0.546662 0 0 0 0 0.554167 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3516_19636",
    result: "effect2_dropShadow_3516_19636"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3516_19636",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dd_3516_19636",
    x: 67.903,
    y: -77.4317,
    width: 198.214,
    height: 194.514,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.3469
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27.737
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.403922 0 0 0 0 0.545098 0 0 0 0 0.552941 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3516_19636"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.04309
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.8254
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.40408 0 0 0 0 0.546662 0 0 0 0 0.554167 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3516_19636",
    result: "effect2_dropShadow_3516_19636"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3516_19636",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_3516_19636",
    x: 62.5167,
    y: 31.5973,
    width: 192.926,
    height: 200.197,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.6587
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.5307
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0875 0 0 0 0 0.0875 0 0 0 0 0.0875 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3516_19636"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3516_19636",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_dd_3516_19636",
    x: 126.91,
    y: -40.9969,
    width: 202.791,
    height: 220.121,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.7002
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28.6005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.403922 0 0 0 0 0.545098 0 0 0 0 0.552941 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3516_19636"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.20009
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.10016
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.40408 0 0 0 0 0.546662 0 0 0 0 0.554167 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3516_19636",
    result: "effect2_dropShadow_3516_19636"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3516_19636",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_dd_3516_19636",
    x: -28.869,
    y: 90.6633,
    width: 223.867,
    height: 217.945,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.7002
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28.6005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.403922 0 0 0 0 0.545098 0 0 0 0 0.552941 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3516_19636"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.20009
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.10016
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.40408 0 0 0 0 0.546662 0 0 0 0 0.554167 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3516_19636",
    result: "effect2_dropShadow_3516_19636"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3516_19636",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3516_19636",
    x1: 92.6903,
    y1: 80.6914,
    x2: 92.5263,
    y2: 235.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3516_19636",
    x1: 126.275,
    y1: 61.3789,
    x2: 126.112,
    y2: 215.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161616"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3516_19636",
    x1: 158.98,
    y1: 43,
    x2: 158.792,
    y2: 211.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3516_19636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.4468,
    height: 37.4468,
    fill: "white",
    transform: "translate(86.875 89.1211) rotate(-30)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3516_19636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.5838,
    height: 45.5838,
    fill: "white",
    transform: "translate(109.564 79.2773) rotate(-15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightsHasLogoEmpty);
export default __webpack_public_path__ + "static/media/highlightsHasLogoEmpty.c9c9bbda9ab3b95e8663c6825a5ffd80.svg";
export { ForwardRef as ReactComponent };